import React from 'react';

import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';

import NoSubContent from './NoSubContent';

const AddSubtitleModal = ({
    availableSubtitleLanguages,
    setAvailableSubtitleLanguages,
    setCurrentSelectedLanguage,
    isAddModalOpen,
    setIsAddModalOpen,
    setShowNoSub
}) => {
    const { t } = useTranslation();

    return (
        <Modal
            open={isAddModalOpen}
            onClose={() => setIsAddModalOpen(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            disablePortal
        >
            <Box className="container-add-subtitle-modal">
                <NoSubContent
                    availableSubtitleLanguages={availableSubtitleLanguages}
                    setAvailableSubtitleLanguages={setAvailableSubtitleLanguages}
                    setCurrentSelectedLanguage={setCurrentSelectedLanguage}
                    setIsAddModalOpen={setIsAddModalOpen}
                    setShowNoSub={setShowNoSub}
                />
                <Box className="btn-group-add-subtitle-modal">
                    <Button onClick={() => setIsAddModalOpen(false)} className="btn-add-subtitle-modal">
                        {t('buttons.cancel')}
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default AddSubtitleModal;